import React from 'react'

const Sunrise = () => {
  return (
    <svg
      width='180'
      height='180'
      viewBox='0 0 180 180'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M89.9999 145.783C120.808 145.783 145.783 120.808 145.783 90C145.783 59.1921 120.808 34.2174 89.9999 34.2174C59.192 34.2174 34.2173 59.1921 34.2173 90C34.2173 120.808 59.192 145.783 89.9999 145.783Z'
        fill='url(#paint0_linear_2_1132)'
        stroke='url(#paint1_linear_2_1132)'
        strokeWidth='2'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M89.9999 0C87.2985 0 85.1086 2.18992 85.1086 4.89131V20.5435C85.1086 23.2449 87.2985 25.4348 89.9999 25.4348C92.7013 25.4348 94.8912 23.2449 94.8912 20.5435V4.8913C94.8912 2.18991 92.7013 0 89.9999 0ZM89.9999 154.565C87.2985 154.565 85.1086 156.755 85.1086 159.457V175.109C85.1086 177.81 87.2985 180 89.9999 180C92.7013 180 94.8912 177.81 94.8912 175.109V159.457C94.8912 156.755 92.7013 154.565 89.9999 154.565ZM128.318 13.848C129.669 11.5086 132.66 10.707 135 12.0577C137.339 13.4084 138.141 16.3999 136.79 18.7393L128.964 32.2945C127.614 34.634 124.622 35.4355 122.283 34.0849C119.943 32.7342 119.142 29.7427 120.492 27.4032L128.318 13.848ZM57.7173 145.915C55.3779 144.564 52.3864 145.366 51.0357 147.705L43.2096 161.261C41.8589 163.6 42.6605 166.592 44.9999 167.942C47.3394 169.293 50.3309 168.491 51.6816 166.152L59.5077 152.597C60.8584 150.257 60.0568 147.266 57.7173 145.915ZM161.261 43.2096C163.6 41.8589 166.592 42.6605 167.942 45C169.293 47.3394 168.491 50.3309 166.152 51.6816L152.597 59.5077C150.257 60.8584 147.266 60.0568 145.915 57.7174C144.564 55.3779 145.366 52.3864 147.705 51.0357L161.261 43.2096ZM34.0849 122.283C32.7342 119.943 29.7427 119.142 27.4032 120.492L13.848 128.318C11.5086 129.669 10.707 132.66 12.0577 135C13.4084 137.339 16.3999 138.141 18.7394 136.79L32.2945 128.964C34.634 127.614 35.4356 124.622 34.0849 122.283ZM175.109 85.1087C177.81 85.1087 180 87.2986 180 90C180 92.7014 177.81 94.8913 175.109 94.8913H159.457C156.755 94.8913 154.565 92.7014 154.565 90C154.565 87.2986 156.755 85.1087 159.457 85.1087H175.109ZM25.4348 90C25.4348 87.2986 23.2449 85.1087 20.5435 85.1087H4.8913C2.18991 85.1087 1.18082e-07 87.2986 0 90C-1.18082e-07 92.7014 2.18992 94.8913 4.89131 94.8913H20.5435C23.2449 94.8913 25.4348 92.7014 25.4348 90ZM166.152 128.318C168.491 129.669 169.293 132.66 167.942 135C166.592 137.339 163.6 138.141 161.261 136.79L147.705 128.964C145.366 127.614 144.564 124.622 145.915 122.283C147.266 119.943 150.257 119.142 152.597 120.492L166.152 128.318ZM34.0849 57.7174C35.4356 55.3779 34.634 52.3864 32.2945 51.0357L18.7393 43.2096C16.3999 41.8589 13.4084 42.6605 12.0577 45C10.707 47.3394 11.5086 50.3309 13.848 51.6816L27.4032 59.5077C29.7427 60.8584 32.7342 60.0568 34.0849 57.7174ZM136.79 161.261C138.141 163.6 137.339 166.592 135 167.942C132.66 169.293 129.669 168.491 128.318 166.152L120.492 152.597C119.142 150.257 119.943 147.266 122.283 145.915C124.622 144.564 127.614 145.366 128.964 147.705L136.79 161.261ZM57.7173 34.0848C60.0568 32.7341 60.8584 29.7426 59.5077 27.4032L51.6816 13.848C50.3309 11.5085 47.3394 10.7069 44.9999 12.0576C42.6605 13.4083 41.8589 16.3998 43.2096 18.7393L51.0357 32.2945C52.3864 34.6339 55.3778 35.4355 57.7173 34.0848Z'
        fill='url(#paint2_linear_2_1132)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_2_1132'
          x1='120.815'
          y1='43.0435'
          x2='71.0925'
          y2='145.21'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.182844' stopColor='#FFE600' />
          <stop offset='0.980542' stopColor='#F09000' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2_1132'
          x1='62.0169'
          y1='22.6891'
          x2='139.16'
          y2='207.983'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFE600' />
          <stop offset='1' stopColor='#9C8D00' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_2_1132'
          x1='156.032'
          y1='23.4782'
          x2='22.4999'
          y2='180'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFE600' />
          <stop offset='1' stopColor='#AA9900' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Sunrise
